/** The ONE station money formatter (/simplify consolidation — was four
 *  identical local `money()` copies across the remittance components). */
const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

export function formatMoneyCents(cents: number): string {
  return usd.format(cents / 100);
}
